import { Container, Row, Col } from "react-bootstrap";
import { useEffect } from "react";
import "./who.css";
const focusAreas = [
  { title: "Legal Advocacy", icon: "⚖️" },
  { title: "Education & Training", icon: "🎓" },
  { title: "Legal Aid & Social Justice", icon: "🤝" },
  { title: "Policy & Research", icon: "📘" },
  { title: "Public Awareness", icon: "📢" },
];

const WhoWeAre = () => {
  useEffect(() => {
    const items = document.querySelectorAll(".focus-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="who-section">
      <Container>
        <Row className="align-items-center">
          {/* LEFT CONTENT */}
          <Col md={4} className="who-text">
            <h3 style={{ color: "#c72800ff" }}>Who We Are</h3>
            <p>
              A national council of advocates and legal professionals committed
              to justice, ethics, constitutional values, and public service.
            </p>
          </Col>

          {/* RIGHT ICONS */}
          <Col md={8}>
            <h3 className="text-center mb-4" style={{ color: "#c72800ff" }}>
              Our Core Focus Areas
            </h3>
            <Row className="justify-content-center">
              {focusAreas.map((item, i) => (
                <Col md={2} sm={4} xs={6} key={i} className="focus-card">
                  <div className="focus-icon">{item.icon}</div>
                  <p>{item.title}</p>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhoWeAre;
